import { CSSProperties } from 'react';

import closelinkWordmarkBlackUrl from '../../../../images/closelink-wordmark-black.svg';
import closelinkWordmarkBlueUrl from '../../../../images/closelink-wordmark-blue.svg';
import closelinkWordmarkWhiteUrl from '../../../../images/closelink-wordmark-white.svg';

interface CloselinkWordmarkProps {
    width?: number;
    height?: number;
    color?: 'black' | 'white' | 'blue';
    style?: CSSProperties;
}

export const CloselinkWordmark = ({ color = 'blue', ...props }: CloselinkWordmarkProps) => {
    const urlMap = {
        white: closelinkWordmarkWhiteUrl,
        black: closelinkWordmarkBlackUrl,
        blue: closelinkWordmarkBlueUrl,
    } as const;

    return <img alt="Closelink" {...props} src={urlMap[color]} />;
};
